import { GraphQLResult } from 'aws-amplify/api';
import { useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { GetMeetingQuery, Meeting, OnUpdateMeetingSubscription } from '@/services/API';
import { getMeeting } from '@/services/graphql/queries';
import { onUpdateMeeting } from '@/services/graphql/subscriptions';
import useNewSubscriptions from '@/services/subscriptions/useNewSubscriptions';
import { callGraphQLApi } from '@/utils/graphQLAPI';
import { getMeetingStatus, MEETING_STATUS } from '../helpers/getMeetingStatus';

export default function useMeetingStatusSubscription(meetingID?: string | null) {
  const [meetingStatus, setMeetingStatus] = useState<MEETING_STATUS | null>(null);
  // initial fetch
  useQuery({
    queryKey: ['meeting status'],
    refetchOnWindowFocus: false,
    enabled: !!meetingID,
    queryFn: async () => {
      if (!meetingID) return null;
      const meetingResponse = await callGraphQLApi<GraphQLResult<GetMeetingQuery>>(getMeeting, {
        id: meetingID,
      });
      return meetingResponse.data?.getMeeting as Meeting;
    },
    onSuccess: (data: Meeting) => {
      if (!data) return;
      setMeetingStatus(getMeetingStatus(data));
    },
  });

  // subscription
  const subscriptions = useMemo(() => {
    return [
      {
        query: onUpdateMeeting,
        variables: {},
        callback: (data: OnUpdateMeetingSubscription) => {
          if (data.onUpdateMeeting?.id === meetingID) {
            setMeetingStatus(getMeetingStatus(data.onUpdateMeeting as Meeting));
          }
        },
      },
    ];
  }, [meetingID]);

  useNewSubscriptions(subscriptions, 'useMeetingStatusSubscription');

  return meetingStatus;
}
